import { style } from 'typestyle';
import {
    COLOR_05,
    FONT_MAIN,
    FONT_WEIGHT_BLACK,
} from '../../../constants';

export const titleClassName = style({
    fontFamily: FONT_MAIN,
    fontWeight: FONT_WEIGHT_BLACK,
    color: COLOR_05,
    fontSize: '30px',
    lineHeight: '38px',
    textTransform: 'uppercase'
});

export const titleEllipsisClassName = style({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
